import type { Voucher, VoucherTariff } from '@src/domains/vouchers/types/voucher';
import { getVoucherState, VoucherState } from '@src/domains/vouchers/core/getVoucherState';
import { isVoucherDownloadable } from '@src/domains/vouchers/core/isVoucherDownloadable';

export const VoucherBlockLayout = {
  PerVoucher: 'per-voucher',
  Combined: 'combined',
} as const;

export type VoucherBlockLayout = (typeof VoucherBlockLayout)[keyof typeof VoucherBlockLayout];

export interface VoucherBlock {
  key: string;
  voucher: Voucher;
  tariffs: VoucherTariff[];
  state: VoucherState;
  isDownloadable: boolean;
}

export interface VoucherBlocks {
  layout: VoucherBlockLayout;
  blocks: VoucherBlock[];
  showsDownloadAll: boolean;
}

export function buildVoucherBlocks(vouchers: Voucher[]): VoucherBlocks {
  const layout = vouchers.length > 1 ? VoucherBlockLayout.PerVoucher : VoucherBlockLayout.Combined;

  return {
    layout,
    showsDownloadAll: layout === VoucherBlockLayout.PerVoucher,
    blocks: vouchers.map((voucher) => ({
      key: voucher.id,
      voucher,
      tariffs: voucher.tariffs,
      state: getVoucherState(voucher),
      isDownloadable: isVoucherDownloadable(voucher),
    })),
  };
}
